import request from "../util/request";
import {APP_KEY,API_URL,WEB_CODE,groupId} from "../util/constants";

export function loginRequest(phone,yzm, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", phone);
    formData.append("yzm",yzm);

    return fetch(API_URL+'/js/login',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getTeacherInfoRequest(phone, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", phone);

    return fetch(API_URL+'/js/getteacherinfo',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getClassSearchInfoRequest(callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", sessionStorage.getItem('teacherphone'));

    return fetch(API_URL+'/js_classguanli/classguanli_juese_new',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
export function getClassListRequest(juese_code,grade, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", sessionStorage.getItem('teacherphone'));
    formData.append("xueqicode", "201809");
    formData.append("juese_code", juese_code);
    formData.append("grade", grade);
    formData.append("type", "paixu");
    formData.append("limit", "20");
    formData.append("offset", "0");

    return fetch(API_URL+'/js_classguanli/newlist',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getStudentListRequest(class_code, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("classcode", class_code);
    formData.append("orderby", "xm");//姓名     //qt 排名
    formData.append("limit", "1000");
    formData.append("offset", '0');

    return fetch(API_URL+'/js/cstudents',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getClassInfoRequest(class_code, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("classcode", class_code);
    formData.append("teacherphone", sessionStorage.getItem('teacherphone'));//姓名     //qt 排名

    return fetch(API_URL+'/js/classdata',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

// export function getClassTongjiRequest(class_code,tongji_code, callback) {
//     let formData = new FormData();
//     formData.append("appkey", "xixin");
//     formData.append("class_code", class_code);
//     formData.append("tongji_code", tongji_code);
//     formData.append("caozuo", "banji_tongji");
//
//     return fetch(API_URL+'/Jsclass/tj',{
//         method: 'post',
//         body: formData,
//     }).then(function (res) {
//         return res.json();
//     }).then(function (json) {
//         callback && callback(json);
//     }).catch(e => {
//         console.error(e);
//         callback && callback(e);
//
//     });
// }

export function getClassTongjiRequest(class_code,tongji_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("classcode", class_code);
    formData.append("tongji_code", tongji_code);
    formData.append("caozuo", "banji_tongji");

    return fetch(API_URL+'/Apiopen/sd',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getBadgeListRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("studentcode", studentcode);

    return fetch(API_URL+'/jzbaogao/getbg_hz',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getBadgeListXueqiRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", 'get_bg_hz');
    formData.append("studentcode", studentcode);

    return fetch(API_URL+'/XueqiBaogao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getFengchaoInfoRequest(class_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "getbanjidata");
    formData.append("studentid", "studentid");
    formData.append("classcode", class_code);

    return fetch(API_URL+'/Apiopen/sd',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

//二维码轮询接口
export function qrCodePollingRequest(str_erweima, callback) {
    let formData = new FormData();
    formData.append("appkey", 'xixin');
    formData.append("caozuo", 'check_erweima_login');
    formData.append("str_erweima",str_erweima);

    return fetch(API_URL+'/Apiopen/login_ewr',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
//人脸入库
export function faceEnterLibraryRequest(img_ali, callback) {
    let formData = new FormData();
    formData.append("appkey", 'xixin');
    formData.append("img_ali", img_ali);
    formData.append("pid",sessionStorage.getItem('studentpid'));
    formData.append("groupId",groupId);

    return fetch(API_URL+'/Apiopen/uploadimg',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
//自评列表
export function getZipingListRequest(class_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("class_code", class_code);
    formData.append("caozuo", "zp_list");

    return fetch(API_URL+'/Apiopen/ziping',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getPingyuRequest(pid,classcode, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "get_stu_pingyu");
    formData.append("pid", pid);
    formData.append("classcode", classcode);

    return fetch(API_URL+'/jzbaogao/getStuInfo',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
